export default __webpack_public_path__ + "static/media/close-red.9e113daa.svg";